import JassEnum from './enum';

/**
 * type volumegroup
 */
export default class JassVolumeGroup extends JassEnum {}
